"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNonUpdateActivityTypes = exports.getActivityTypes = exports.additionalFilters = exports.customerFilterKeys = exports.filterKeys = void 0;
const types_1 = require("../../../features/ActivityFeedV2/types");
exports.filterKeys = ['deviation', 'deviationRisk', 'messages', 'updates'];
exports.customerFilterKeys = ['quotes', 'users', 'documents'];
exports.additionalFilters = ['communication'];
const getActivityTypes = (filterKey, availableUpdateActivities) => {
    if (filterKey === 'updates' && availableUpdateActivities.length > 0) {
        return availableUpdateActivities;
    }
    return filterKeyActivityMap[filterKey];
};
exports.getActivityTypes = getActivityTypes;
const filterKeyActivityMap = {
    deviation: [types_1.ActivityType.DeviationInsight],
    deviationRisk: [types_1.ActivityType.DeviationRiskInsight],
    messages: [types_1.ActivityType.MessageFeedV1],
    communication: [types_1.ActivityType.CommunicationFeedV1],
    updates: [
        types_1.ActivityType.BookingConfirmedByCarrier,
        types_1.ActivityType.ShipmentUpdateFeedV1,
        types_1.ActivityType.UpdateShipment,
        types_1.ActivityType.TransportPlanUpdatedFeedV1,
        types_1.ActivityType.ChangeCargoReadyDate,
        types_1.ActivityType.ChangeContainerYardCutOffDate,
        types_1.ActivityType.ChangePickup,
        types_1.ActivityType.ChangeEstimatedTimeDeparture,
        types_1.ActivityType.ChangeArrival,
        types_1.ActivityType.ChangeDelivery,
        types_1.ActivityType.UpdatePartnerBookingStatus,
        types_1.ActivityType.CargoRollover,
        types_1.ActivityType.UpdateInsight,
        types_1.ActivityType.ReassuranceInsight,
    ],
    quotes: [types_1.ActivityType.ManualQuoteFeedV1, types_1.ActivityType.ManualQuoteDeclineFeedV1],
    users: [types_1.ActivityType.CompanyUserUpdateFeedV1],
    documents: [types_1.ActivityType.DocumentUploadFeedV1],
};
const getNonUpdateActivityTypes = (filters) => filters.flatMap((filterKey) => (filterKey !== 'updates' ? filterKeyActivityMap[filterKey] : []));
exports.getNonUpdateActivityTypes = getNonUpdateActivityTypes;
//# sourceMappingURL=activityFiltersConfig.js.map